import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Alert } from 'shared/mui/Alert/Alert';
import { ListItem } from 'shared/mui/List';

export const NotificationPopperAlert: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <ListItem
      sx={{
        padding: '16px',
      }}
    >
      <Alert severity="info" sx={{ width: '100%' }}>
        {translate('app.notificationPopper.noNotifications')}
      </Alert>
    </ListItem>
  );
};
